module.exports = __webpack_public_path__ + "static/media/logo-fortis.74d64843.svg";